<div
  *ngIf="isDatasetValid"
  class="simple-line-chart"
>
  <canvas
    #chart
    class="simple-line-chart__canvas"
  ></canvas>
</div>
